import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateImageLibraryQuery } from '../ImageLibrary/useImageLibraryQuery';

export const useImageAttachmentByUrlMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: Api.IFileAttachmentWithURL) => void;
}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			url,
			fileName,
			addToLibrary = false,
			impersonationContext,
		}: {
			url: string;
			fileName?: string;
			/** Set by the content surfaces so the stock pick also joins the account's reusable image library */
			addToLibrary?: boolean;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IFileAttachmentWithURL>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'attachment/externalImage',
					impersonationContext,
				}),
				'POST',
				{
					url,
					fileName,
					addToLibrary,
				}
			);
		},
		onError,
		onSuccess: (result, variables) => {
			if (variables.addToLibrary) {
				invalidateImageLibraryQuery();
			}
			onSuccess?.(result);
		},
	});
};
